import { hotRanking, rankingHighlight } from '@/mocks/home';
import SectionHeading from '@/components/base/SectionHeading';

const maxHeat = Math.max(...hotRanking.map((item) => item.heat));

function renderTrend(trend: string, change: number) {
  if (trend === 'up') {
    return (
      <span className="flex items-center gap-1 font-label text-[11px] text-primary-700">
        <i className="ri-arrow-up-line" />
        {change}
      </span>
    );
  }
  if (trend === 'down') {
    return (
      <span className="flex items-center gap-1 font-label text-[11px] text-foreground-400">
        <i className="ri-arrow-down-line" />
        {change}
      </span>
    );
  }
  return (
    <span className="flex items-center gap-1 font-label text-[11px] text-foreground-400">
      <i className="ri-subtract-line" />
      持平
    </span>
  );
}

export default function HotRanking() {
  return (
    <section id="ranking" className="w-full scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="榜单 / 热度"
            title="热度榜 · 本周速览"
            desc="依据浏览与收藏综合排序，把当前关注度最高的合集与索引排在最前，先看最值得看的那几条。"
          />
          <a
            href="#collections"
            className="flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 font-label text-[13px] text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看全部榜单
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="rounded-xl border border-background-200 bg-background-100/60 p-2 lg:col-span-7">
            <ul className="divide-y divide-background-200">
              {hotRanking.map((item) => (
                <li
                  key={item.rank}
                  className="group flex items-center gap-4 rounded-lg px-3 py-4 transition-colors hover:bg-background-50"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                      item.rank <= 3
                        ? 'bg-accent-500 text-foreground-950'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="truncate font-label text-sm text-foreground-900">
                        {item.title}
                      </span>
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[10px] text-secondary-900">
                        {item.category}
                      </span>
                    </div>
                    <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-primary-400"
                        style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                      />
                    </div>
                  </div>
                  <div className="flex shrink-0 flex-col items-end gap-1">
                    <span className="font-heading text-sm font-bold text-foreground-900">
                      {item.heat.toLocaleString()}
                    </span>
                    {renderTrend(item.trend, item.change)}
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50 lg:col-span-5">
            <div className="relative h-48 w-full overflow-hidden bg-background-100">
              <img
                src={rankingHighlight.image}
                alt={rankingHighlight.title}
                title={`${rankingHighlight.title} - 黑料总站热度榜`}
                className="h-full w-full object-cover object-top"
              />
              <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 font-label text-[11px] text-foreground-950">
                <i className="ri-trophy-line" />
                TOP 1
              </span>
            </div>
            <div className="p-5">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900">
                  {rankingHighlight.category}
                </span>
                <span className="font-label text-[11px] text-foreground-500">
                  {rankingHighlight.updated}
                </span>
              </div>
              <h4 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                {rankingHighlight.title}
              </h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {rankingHighlight.desc}
              </p>
              <div className="mt-5 flex items-center gap-6 border-t border-background-200 pt-4">
                <div>
                  <p className="font-heading text-base font-bold text-foreground-950">
                    {rankingHighlight.heat.toLocaleString()}
                  </p>
                  <p className="font-label text-[11px] text-foreground-500">热度值</p>
                </div>
                <div>
                  <p className="font-heading text-base font-bold text-foreground-950">
                    {rankingHighlight.collect.toLocaleString()}
                  </p>
                  <p className="font-label text-[11px] text-foreground-500">收藏数</p>
                </div>
                <a
                  href="#collections"
                  className="ml-auto flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 font-label text-[13px] text-background-50 transition-colors hover:bg-foreground-800"
                >
                  立即查看
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}